import { INavigationItem } from "../../../core/models/navigation/INavigationItem";
import { PanneauLectureTerminalComponent } from "../components/panneaux/panneau-lecture-terminal/panneau-lecture-terminal.component";

export const EHomeItems: Record<string, INavigationItem> = {
  LectureVitale: {
    iconName: 'lecturecv',
    label: 'Lecture carte Vitale',
    route: [],
    badgeCount: 0,
		moduleOptionnel:"DPLV",
		isCustomIcone : true,
    openOverlay: PanneauLectureTerminalComponent
  },
	Patients: {
    iconName: 'group',
    label: 'Patients',
    route: ['patients'],
    badgeCount: 0,
		isCustomIcone : false
  },
  Ordonnances: {
    iconName: 'contract',
    label: 'Ordonnances',
    route: ['ordonnances'],
    badgeCount: 0,
  },
  Transmissions: {
    iconName: 'backup_table',
    label: 'Transmissions',
    route: ['transmissions'],
    badgeCount: 0
  },
  Tournees: {
    iconName: 'directions_car',
    label: 'Tournées',
    route: ['tournees'],
    badgeCount: 0,
  },
  Planning: {
    iconName: 'calendar_month',
    label: 'Planning infirmier',
    route: ['planning'],
    badgeCount: 0,
  },
  Contacts: {
    iconName: 'phone',
    label: 'Prescripteurs et contacts',
    route: ['contacts'],
    badgeCount: 0,
  },
  Facturation: {
    iconName: 'invoice-euro',
    label: 'Facturation',
    route: ['facturation'],
    badgeCount: 0,
		isCustomIcone : true
  },
  Teletransmission: {
    iconName: 'upload',
    label: 'Télétransmissions',
    route: ['teletransmission'],
    badgeCount: 0,
    onlyDesktop: true,
  },
  SuiviFacturation: {
    iconName: 'checklist_rtl',
    label: 'Suivi des factures',
    route: ['suivi-facturation'],
    badgeCount: 0
  },
  Retrocession: {
    iconName: 'partner_exchange',
    label: 'Rétrocessions',
    route: ['retrocession'],
    badgeCount: 0,
  },
  Parametres: {
    iconName: 'settings',
    label: 'Paramétrages',
    route: ['parametres'],
    badgeCount: 0,
  }
};
